import { createEntityAdapter, createSelector, createSlice } from '@reduxjs/toolkit';
import {
  createInventoryLocation,
  editInventoryLocation,
  loadInventoryLocation,
  loadInventoryLocations,
  removeInventoryLocation,
} from '@sophocles/features/inventory/inventoryLocations/api';
import InventoryLocationSchema from '@sophocles/features/inventory/inventoryLocations/schema';
import { normalize } from 'normalizr';

const inventoryLocationsAdapter = createEntityAdapter();

const slice = createSlice({
  name: 'inventoryLocations',
  initialState: inventoryLocationsAdapter.getInitialState({
    view: {
      search: null,
      page: 0,
      order: 'asc',
      orderBy: 'id',
    },
  }),
  reducers: {
    setPage(state, action) {
      state.view.page = action.payload;
    },
    setSearch(state, action) {
      state.view.search = action.payload;
    },
    setOrder(state, action) {
      state.view.order = action.payload;
    },
    setOrderBy(state, action) {
      state.view.orderBy = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(loadInventoryLocations.fulfilled, (state, action) => {
        const { entities } = normalize(action.payload.results, [InventoryLocationSchema]);
        inventoryLocationsAdapter.upsertMany(state, entities.inventoryLocations ?? {});
      })
      .addCase(loadInventoryLocations.rejected, (state, action) => {})
      .addCase(loadInventoryLocation.fulfilled, (state, action) => {
        const { entities, result } = normalize(action.payload, InventoryLocationSchema);
        inventoryLocationsAdapter.upsertOne(state, entities.inventoryLocations[result]);
      })
      .addCase(loadInventoryLocation.rejected, (state, action) => {})
      .addCase(createInventoryLocation.fulfilled, (state, action) => {
        const { entities, result } = normalize(action.payload, InventoryLocationSchema);
        inventoryLocationsAdapter.addOne(state, entities.inventoryLocations[result]);
      })
      .addCase(createInventoryLocation.rejected, (state, action) => {})
      .addCase(editInventoryLocation.fulfilled, (state, action) => {
        const { entities, result } = normalize(action.payload, InventoryLocationSchema);
        inventoryLocationsAdapter.upsertOne(state, entities.inventoryLocations[result]);
      })
      .addCase(editInventoryLocation.rejected, (state, action) => {})
      .addCase(removeInventoryLocation.fulfilled, (state, action) => {
        inventoryLocationsAdapter.removeOne(state, action.payload);
      })
      .addCase(removeInventoryLocation.rejected, (state, action) => {});
  },
});

export const selectInventoryLocationEntities = state => {
  return state.inventory.inventoryLocations;
};

export const { selectById } = inventoryLocationsAdapter.getSelectors(selectInventoryLocationEntities);

export const selectInventoryLocation = id => state => selectById(state, id);

export const getInventoryLocationsViewProperties = createSelector(selectInventoryLocationEntities, state => state.view);

export const {
  setPage: setInventoryLocationsPage,
  setSearch: setInventoryLocationsSearch,
  setOrder: setInventoryLocationsOrder,
  setOrderBy: setInventoryLocationsOrderBy,
} = slice.actions;

const { reducer } = slice;
export default reducer;
